<template>
  <div>
    <Navbar :forceBg="true" />
    <section class="conteudo text-left">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Acessando de um Computador</h1>
            <p>
              Pra você aproveitar a nossa Lista de IPTV de um computador é muito simples. Veja algumas opções:
            </p>
          </div>
        </div>

        <div class="row">


            <div class="col-md-12">
            
                <nossoplayerweb></nossoplayerweb>
                <vlc></vlc>

            </div>

        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
<script>
import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

import nossoplayerweb   from "@/views/tutoriais/apps/nossoplayer-web.vue";
import vlc              from "@/views/tutoriais/apps/vlc.vue";

export default {
  components: {
    Navbar,
    Footer,
    nossoplayerweb,
    vlc
  },
};
</script>